import React from "react";
import moment from "moment";

import NotSetValue from "./NotSetValue";
import { FormattedMessage } from "react-intl";
import { Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";

type UserInfoSummaryProps = {
    userInfos: any[];
};

const UserInfoSummary: React.FC<UserInfoSummaryProps> = ({ userInfos }) => {
    if (userInfos.length == 0) return <NotSetValue label="user_info.empty" />;

    let rows = [];
    userInfos.forEach((info, index) => {
        rows.push(
            <TableRow key={index}>
                <TableCell>{info.client.display_name}</TableCell>
                <TableCell>{info.ip}</TableCell>
                <TableCell>{moment(info.last_visit).format("YYYY-MM-DD HH:mm")}</TableCell>
            </TableRow>,
        );
    });

    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>
                        <FormattedMessage id="user_info.client" />
                    </TableCell>
                    <TableCell>
                        <FormattedMessage id="user_info.ip" />
                    </TableCell>
                    <TableCell>
                        <FormattedMessage id="user_info.time" />
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>{...rows}</TableBody>
        </Table>
    );
};

export default UserInfoSummary;
